import { useTranslation } from 'react-i18next';

export const useTabs = () => {
  const { t } = useTranslation();
  return [
    { label: t('common.labels.details'), to: '../details' },
    { label: t('common.tabs.audit_logs'), to: '../audit-logs' },
  ];
};
